export const INVESTOR_NETWORK_TABS = [
    'portfolio',
    'startups',
    'applied-startups',
    'investors',
    'users',
    'documents',
    'activity'
];

export const INVESTOR_NETWORK_NAV_ITEMS = [
    { id: 'portfolio', label: 'Portfolio', icon: 'M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4' },
    { id: 'startups', label: 'Startups', icon: 'M13 10V3L4 14h7v7l9-11h-7z' },
    { id: 'applied-startups', label: 'Applied Startups', icon: 'M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2V9l-4-4H9zM9 3v6h6' },
    { id: 'investors', label: 'Investors', icon: 'M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z' },
    { id: 'users', label: 'Management', icon: 'M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z' },
    { id: 'documents', label: 'Documents', icon: 'M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z' },
    { id: 'activity', label: 'Activity', icon: 'M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z' }
];

export function investorNetworkTabPath(tenantPath, tab) {
    if (!tab || tab === 'portfolio') return `/${tenantPath}/investor-network`;
    return `/${tenantPath}/investor-network/${tab}`;
}

export function resolveInvestorNetworkActiveTab(tabParam) {
    if (tabParam && INVESTOR_NETWORK_TABS.includes(tabParam)) return tabParam;
    return 'portfolio';
}
